export default __webpack_public_path__ + "static/media/2131.6b4a408a.png";